import { render, staticRenderFns } from "./PremiumReport.vue?vue&type=template&id=44846e6c&"
import script from "./PremiumReport.js?vue&type=script&lang=js&"
export * from "./PremiumReport.js?vue&type=script&lang=js&"
import style0 from "./PremiumReport.vue?vue&type=style&index=0&id=44846e6c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports